/**
 * Buchungsstrecke C2 — „Wir halten Ihnen den Termin bis … frei.“ auf der öffentlichen
 * Angebotsseite.
 *
 * Eigene, abgegrenzte Komponente, damit die Angebotsseite (`pages/offer-public.tsx`) nur EINE Zeile
 * dafür trägt. Die Regel, OB eine Reservierung läuft (Schalter des Betriebs an, Frist gesetzt und
 * offen, Angebot offen), steht auf dem Server (sql/595 `get_public_offer_terminreservierung`); hier
 * wird nur angezeigt, was ankommt — plus eine Sicherung, falls die Seite über die Frist hinaus
 * offen bleibt. Nur ein Datum: kein Countdown, keine Uhr (UWG Anhang Nr. 7).
 */
import { Icon } from "./components";

export function terminReservierungText(bis: string, lang: "de" | "en"): string {
  const datum = new Date(bis).toLocaleDateString(lang === "de" ? "de-DE" : "en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "Europe/Berlin",
  });
  return lang === "de" ? `Wir halten Ihnen den Termin bis ${datum} frei.` : `We are holding the date for you until ${datum}.`;
}

export function TerminReservierungHinweis({
  reservierung,
  lang,
  jetzt = new Date(),
}: {
  reservierung: { bis: string } | null | undefined;
  lang: "de" | "en";
  jetzt?: Date;
}) {
  const bis = reservierung?.bis;
  if (!bis) return null;
  const ms = new Date(bis).getTime();
  if (!Number.isFinite(ms) || ms <= jetzt.getTime()) return null;
  return (
    <p
      data-testid="termin-reservierung-hinweis"
      className="mx-auto mt-3 inline-flex max-w-2xl items-center justify-center gap-1.5 font-body-md text-body-md text-on-background dark:text-inverse-on-surface"
    >
      <Icon name="event_available" className="shrink-0 text-[18px] text-secondary dark:text-secondary-fixed-dim" />
      {terminReservierungText(bis, lang)}
    </p>
  );
}
